import { Transition } from 'framer-motion';
import { motion } from '../../lib/motion';
import { ReactNode } from 'react';

interface PageTransitionProps {
    children: ReactNode;
    className?: string;
    shouldAnimate?: boolean;
}

const pageVariants = {
    initial: {
        opacity: 0,
        y: 20, // increased slightly for better "slide up" feel
    },
    in: {
        opacity: 1,
        y: 0,
    }
};

const pageTransition: Transition = {
    type: "tween",
    ease: [0.4, 0, 0.2, 1],
    duration: 0.3
};

export const PageTransition = ({ children, className = "", shouldAnimate = true }: PageTransitionProps) => {
    if (!shouldAnimate) {
        return <div className={`w-full ${className}`}>{children}</div>;
    }

    return (
        <motion.div
            initial="initial"
            animate="in"
            variants={pageVariants}
            transition={pageTransition}
            className={`w-full ${className}`}
        >
            {children}
        </motion.div>
    );
};
